<script>
  import { createEventDispatcher } from "svelte";
  import { quintOut } from "svelte/easing";
  import { blur, fly } from "svelte/transition";

  export let show = false;
  export let width = "container_drawer";
  export let lightXColour = false;
  export let zindex = "z-40";

  const dispatch = createEventDispatcher();

  const handleClose = () => {
    show = false;
    dispatch("close");
  };

  function handleWindowKeyDown(event) {
    if (event.key === "Escape" && show) {
      handleClose();
    }
  }
</script>

<svelte:window on:keydown={handleWindowKeyDown} />

{#if show}
  <div
    class="fixed top-0 ltr:right-0 rtl:left-0 {zindex} w-full h-full drawer"
    out:blur={{ amount: 10, duration: 800 }}
  >
    <!-- Backdrop -->
    <div
      class="opacity-80 fixed top-0 ltr:right-0 rtl:left-0 w-full h-full bg-black cursor-pointer"
      on:click={handleClose}
      on:keydown={handleClose}
    />

    <div
      class="{width} {$$props.class} fixed ltr:right-0 rtl:left-0 h-full bg-pbg-50 shadow-2xl"
      in:fly={{ x: 200, duration: 1000, opacity: 0.8, easing: quintOut }}
      out:fly={{ x: 200, duration: 500, opacity: 1, easing: quintOut }}
    >
      <div class="flex flex-row flex-grow w-full h-full">
        <div class="w-full h-full py-0">
          <slot />
        </div>
        <div
          class="absolute ltr:right-0 rtl:left-0 h-16"
          class:x_in_menu={$$slots.menu}
          class:light-x={lightXColour}
        >
          <div class="flex flex-shrink-0 text-textpbg-700">
            <div class="hover:animate-pulse w-16">
              <div
                on:click={handleClose}
                on:keydown={handleClose}
                class="flex items-center justify-center h-16 cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 h-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="flex flex-shrink-0">
            <slot name="menu" />
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style lang="postcss">
  .container_drawer {
    top: theme("spacing.16");
    @apply w-[calc(100%-theme("spacing.80")+theme("spacing.8"))] 2xl:w-[calc(100%-theme("spacing.80"))];
  }

  .x_in_menu {
    @apply bg-pbg-100;
  }

  .light-x {
    @apply text-primary-500;
  }
</style>
